import * as React from 'react';
import * as PropTypes from 'prop-types';
import { map } from 'lodash';
import cn from 'classnames';
import styles from 'components/Steps/Steps.module.scss';

function Steps(props) {
  function renderStepItem(step, index, isLast) {
    const { title, className: stepTitleClassName } = step;
    const { activeStepIndex, createStepClickHandler } = props;
    const stepActive = index === activeStepIndex ? '' : styles.notActive;
    const stepComplete = index >= activeStepIndex ? '' : styles.active;
    const stepDisabled = index !== 6 && activeStepIndex === 6 ? styles.disabled : stepComplete;

    const classNames = cn([
      styles.stepItem,
      stepActive,
      stepDisabled,
      { [styles.withoutTitle]: !title },
    ]);

    const handleClick = createStepClickHandler
      ? props.createStepClickHandler(props, {
          step,
          index,
          isLast,
          stepActive,
          stepComplete,
          stepDisabled,
        })
      : () => null;

    return (
      <div key={index} className={classNames} onClick={handleClick}>
        <div className={styles.stepNumber}>{!stepComplete && index + 1}</div>
        {step.title && (
          <div className={`${styles.stepTitle} ${stepTitleClassName}`}>
            <div className={styles.stepText}>{step.title}</div>
          </div>
        )}
      </div>
    );
  }

  return (
    <>
      <div className={styles.steps}>
        {map(props.stepsMap, (step, index) =>
          renderStepItem(step, index, props.stepsMap.length === index + 1),
        )}
      </div>
      {props.hasWrapper ? (
        <div className="white-block white-block__pad40">{props.children}</div>
      ) : (
        props.children
      )}
    </>
  );
}

Steps.propTypes = {
  activeStepIndex: PropTypes.number,
  stepsMap: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      title: PropTypes.string,
    }),
  ).isRequired,
  createStepClickHandler: PropTypes.func,
  children: PropTypes.node,
  hasWrapper: PropTypes.bool,
};
Steps.defaultProps = {
  hasWrapper: false,
  stepTitleClassName: '',
};

export default Steps;
